module.exports = __webpack_public_path__ + "img/phone.f61c0c7a.svg";